import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgProvidersIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M18.277 8a1.992 1.992 0 0 0 3.137.414A2 2 0 0 0 20 5c-.738 0-1.376.404-1.723 1H16V4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H5.723a1.992 1.992 0 0 0-3.137-.414A2 2 0 0 0 4 9c.738 0 1.376-.404 1.723-1H8v.369C5.133 9.84 4.318 12.534 4.091 14H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.983.983 0 0 0 9 11h6a.98.98 0 0 0 .792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277ZM6 18H4v-2h2v2Zm14 0h-2v-2h2v2Zm-6-9h-4V5h4v4Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgProvidersIcon);
export default ForwardRef;
